import { render, staticRenderFns } from "./NIMStudentForm.vue?vue&type=template&id=f5f43e82&scoped=true&"
import script from "./NIMStudentForm.vue?vue&type=script&lang=js&"
export * from "./NIMStudentForm.vue?vue&type=script&lang=js&"
import style0 from "./NIMStudentForm.vue?vue&type=style&index=0&id=f5f43e82&prod&scoped=true&lang=scss&"
import style1 from "./NIMStudentForm.vue?vue&type=style&index=1&id=f5f43e82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f43e82",
  null
  
)

export default component.exports